<div class="container">
  <h1>Plan Your Catered Event at U-M</h1>
  <p>Ready to book catering for your event? Find the right contact based on your event location and take the next step
    in planning a seamless dining experience. Select your venue below to get started!</p>

  <h3>Catering Services by Location</h3>
  <br>
  <div class="catering-option">
    <P><b>Michigan Union, Michigan League, or Pierpont Commons</b></P>
    <p style="margin-left: 20px;">
      <a href="https://conferences.umich.edu/contact/?message=Catering%20and%20Events%20at%20Michigan%20League,%20Pierpont%20Commons,%20Michigan%20Union%20"
        target="_blank">
        Contact Conference & Event Services
      </a>
    </p>
  </div>

  <div class="catering-option">
    <p><b>University of Michigan Golf Course</b></p>
    <p style="margin-left: 20px;">
      Email: <a href="mailto:ath-specialevents@umich.edu">ath-specialevents@umich.edu</a>
    </p>
  </div>

  <div class="catering-option">
    <p><b>All Other Locations</b></p>
    <p style="margin-left: 20px;">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSc3JyFHfd3Y42UM8kH1WvXjY7IPAo8WSoVpsNXv0uYKEyEIXA/viewform "
        target="_blank">
        Contact Conference & Event Services (Off-Premise)
      </a>
    </p>
  </div>

  <div class="catering-option">
    <p><b>Catering To Go</b></p>
    <p style="margin-left: 20px;">
      <a href="https://dining.umich.edu/catering/catering-to-go/" target="_blank">
        View Catering To Go Options
      </a>
    </p>
  </div>

</div>